import './index.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import Login from './Login';
import { resolveSession } from './auth';

/*
  Authentication gate.

  App.js resolves a Cognito token at MODULE scope (`await kiblOddsCognito
  .getToken()`), so it runs on import, before React renders anything. There is
  therefore no point inside App at which a login screen could be shown — the
  gate has to sit in front of the import.

  So: resolve the session first, and only import App once we have one. On a
  fresh sign-in we reload rather than importing inline, so App's module-scope
  bootstrap runs against a session that is already in localStorage.
*/

const root = ReactDOM.createRoot(document.getElementById('root'));

function showLogin() {
  root.render(
    <React.StrictMode>
      <Login onSuccess={() => window.location.reload()} />
    </React.StrictMode>
  );
}

async function start() {
  const session = await resolveSession();

  if (!session) {
    showLogin();
    return;
  }

  const { default: App } = await import('./App');

  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

start();
